var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApplicationsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 0H1.75C0.785406 0 0 0.784656 0 1.75V4.19994H14V1.75C14 0.784656 13.2146 0 12.25 0ZM10.15 2.80006H9.45009C9.25686 2.80006 9.10013 2.6432 9.10013 2.45009C9.10013 2.25686 9.25698 2.10013 9.45009 2.10013H10.15C10.3433 2.10013 10.5 2.25698 10.5 2.45009C10.5 2.64321 10.3431 2.80006 10.15 2.80006ZM12.25 2.80006H11.5501C11.3568 2.80006 11.2001 2.6432 11.2001 2.45009C11.2001 2.25686 11.357 2.10013 11.5501 2.10013H12.25C12.4432 2.10013 12.6 2.25698 12.6 2.45009C12.6 2.64321 12.4432 2.80006 12.25 2.80006Z",
    fill: "#4F6E90"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 12.25C0 13.2153 0.785406 14 1.75 14H12.25C13.2146 14 14 13.2153 14 12.25V4.90001H0V12.25Z",
    fill: "#8DADD0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplicationsIcon);
export default __webpack_public_path__ + "static/media/applications-icon.418f4dba6ec40cce3031a214457a34de.svg";
export { ForwardRef as ReactComponent };